import { produce } from 'immer';
import { ALL_THEME_BACKGROUND_PROPERTIES } from '../../types/themeBackgroundTypes';
import { ALL_THEME_TABLE_PROPERTIES } from '../../types/themeTableTypes';
import { SET_THEME_BACKGROUND, SET_THEME_TABLE } from '../actions/themeActions';
const initialState = {};
const themeReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case SET_THEME_BACKGROUND: {
                draft.themeBackground = { ...ALL_THEME_BACKGROUND_PROPERTIES[action.payload] };
                break;
            }
            case SET_THEME_TABLE: {
                draft.themeTable = { ...ALL_THEME_TABLE_PROPERTIES[action.payload] };
                break;
            }
        }
    });
};
export default themeReducer;
